export function converterMaiuscula(string) {
  const substring = string.toLowerCase().replace(/(?:^|\s)\S/g, function(p) {
    return p.toUpperCase();
  });
  return substring;
}
export function expressaoRegEmail() {
  let regexEmail = /[^\n]+@\S+\.\S+/;
  return regexEmail;
}
